import React from 'react';
import { Card } from '../../../CommonComponents/OPL/Card/Card';
import { Text } from '../../../CommonComponents/OPL/Text/Text';

interface Props {
  title: string | React.ReactElement;
  textAlign?: 'center' | 'left';
  width?: number;
}

export const StepCard: React.FC<Props> = ({
  title,
  textAlign = 'center',
  width = 640,
  children,
}) => {
  return (
    <Card width={width} p="32" mx="auto" mt={96}>
      {typeof title === 'string' ? (
        <Text as="h1" fontSize="h5" fontWeight={500} textAlign={textAlign} mb="32">
          {title}
        </Text>
      ) : (
        title
      )}

      {children}
    </Card>
  );
};
